import React from "react";
import Bredcom from "../../Bradcom/Main";
import Rooms from "../../Menhome/Rooms";
// import Book from '../../Menhome/Book';
import { Helmet } from "react-helmet-async";

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hotel La Finca Zotoluca | Habitaciones</title>
        <meta
          name="description"
          content="Contamos con 2 tipos de habitaciones diseñadas para ofrecer un espacio cómodo y acogedor para nuestros huéspedes."
        />
      </Helmet>
      <main>
        <Bredcom
          title={"Habitaciones"}
          subtitle={"Inicio"}
          newtitle={"Habitaciones"}
        />
        <Rooms />
      </main>
    </>
  );
};

export default Main;
